import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import logoFooter from "../../assets/logoFooter.png";
import { getFirestore } from "../../config/firebase";
import { useLocation } from "react-router-dom";
import { saveTrackingParams } from "../../utils/utmTracker";
import { buildRouteWithUtms, saveUtmParams } from "../../config/whatsappConfig";

const FOOTER_PHONE = "0810-444-1111";
const FOOTER_PHONE_TEL = "08104441111";

const ICON_TELEFONO = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ verticalAlign: "middle" }}
  >
    <path
      d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V20a1 1 0 01-1 1C10.07 21 3 13.93 3 5a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.46.57 3.58a1 1 0 01-.24 1.01l-2.2 2.2z"
      fill="#fff"
    />
  </svg>
);

const Footer = ({ bg }) => {
  // Guardar todos los params de tracking (utm_*, gad_*, gclid, etc.) al cargar
  saveTrackingParams();
  saveUtmParams();

  const location = useLocation();
  const [redesSociales, setRedesSociales] = useState([]);

  // useEffect(() => {
  //   const obtenerDatos = async () => {
  //     const db = getFirestore();
  //     try {
  //       const data = await db.collection("fiat-informacion").get();
  //       const arrayData = data.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  //       setRedesSociales(arrayData[0]);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };
  //   obtenerDatos();
  // }, []);

  useEffect(() => {
    // Función para cargar datos desde localStorage o Firebase
    const cargarDatos = async () => {
      // Verificar si los datos ya están en localStorage
      const datosLocales = localStorage.getItem("redesSociales-fiat");
      if (datosLocales) {
        // Parsear los datos de localStorage y establecerlos en el estado
        setRedesSociales(JSON.parse(datosLocales));
      } else {
        // Si no están en localStorage, obtenerlos de Firebase
        const db = getFirestore();
        try {
          const datos = await db.collection("fiat-informacion").get();
          const arrayDatos = datos.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
          setRedesSociales(arrayDatos[0]);
          // Almacenar los datos en localStorage
          localStorage.setItem("redesSociales-fiat", JSON.stringify(arrayDatos[0]));
        } catch (error) {
          console.log(error);
        }
      }
    };

    // Llamar a la función para cargar datos
    cargarDatos();
  }, []);

  return (
    <>
      <Container fluid className="footer mt-4">
        <Container>
          <Row className="align-items-center pt-3">
            <Col xs={12} md={3} className="mb-3 mb-md-0 text-sm-start text-center columnas-foots-centrar-mobile">
              <Link to={buildRouteWithUtms("/todos", location.search)}>
                <img src={logoFooter} alt="Montironi Fiat" className="img-fluid" />
              </Link>
            </Col>
            <Col xs={12} md={6} className="mb-3 mb-md-0 text-start text-md-center pt-md-0 pt-3">
              <span style={{ fontWeight: 300, fontFamily: "inherit", color: "#fff" }}>Teléfono: </span>
              <span style={{ margin: "0 8px", verticalAlign: "middle" }}>{ICON_TELEFONO}</span>
              <a
                href={`tel:${FOOTER_PHONE_TEL}`}
                style={{ color: "#fff", textDecoration: "underline", fontFamily: "inherit" }}
              >
                {FOOTER_PHONE}
              </a>
            </Col>
            <Col xs={12} md={3} className="social d-flex align-items-center columna-seguinos-en justify-content-md-end">
              <p>Seguinos en:</p>
              <div>
                {redesSociales.redes &&
                  redesSociales.redes.map((red) => {
                    return red.disponible ? (
                      <a href={red.url} target="_blank" rel="noreferrer" className="px-2" key={red.url}>
                        <img src={red.url_icon} alt="Logo" />
                      </a>
                    ) : null;
                  })}
              </div>
            </Col>
            <Col md={12} xs={12} className="pt-3 ocultar-mobile-legal">
              <p className="legal">
                El contenido de este sitio web no debe ser considerado oferta y puede ser actualizado <br /> de forma
                parcial o total sin previo aviso.
              </p>
            </Col>
            <Col md={12} xs={12} className="pt-3 mostrar-mobile-legal">
              <p className="legal">
                El contenido de este sitio web no debe ser considerado oferta y puede ser actualizado <br /> de forma
                parcial o total sin previo aviso.
              </p>
            </Col>
          </Row>
        </Container>
      </Container>
      <Container fluid className="copyright">
        <Container>
          <Row>
            <Col md={12} xs={12} className="text-center">
              <p>
                Copyright © {new Date().getFullYear()} Montironi Fiat - Todos los derechos reservados - Políticas de
                Seguridad
              </p>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
};

export default Footer;
